import React from "react";
import { Box, Button, Text, VStack, Heading, Divider, HStack } from "@chakra-ui/react";
import styles from "./Ace.module.css";
import { connect } from "react-redux";

const Corrections = (props) => {
  // console.log(props.ace.current);
  // console.log(track);
  // var track = useMemo(() => {
  //   return props.corrections;
  // }, [props.corrections]);
  // const SearchText = useContext(SearchContext);
  // console.log(SearchText.corrections);
  // try {
  //   var track = props.ace.current.state.track;
  // } catch {
  //   var track = [];
  // }
// console.log(props.ace);
  let moveToPosition = function (a) {
    if (!a.endCol) {
      props.ace.current.editor.gotoLine(a.startRow + 1, a.startCol);
    } else {
      props.ace.current.editor.session.selection.setRange({
        start: { row: a.startRow, column: a.startCol },
        end: { row: a.endRow, column: a.endCol },
      });
    }
    props.ace.current.editor.scrollToLine(a.startRow, true);
  };

  const acceptChanges = (a, i) => {
    ;
    if (a.className.indexOf("Ace_deleted_marker") === 0) {
      let text = document.querySelector(".text");
      text.classList.add(styles.accepted_text);
    }
  };

  return (
    <VStack overflowY="auto" overflowX="hidden" height="100%" scrollbar-width="thin">
      {props.corrections && props.corrections.length > 0 ? (
        props.corrections.map((a, i) => {
          // console.log(a.index);
          // console.log(i);
          var mode =
            a.className.indexOf("Ace_added_marker") === 0 ? "Added" : "Deleted";
          var bgColor = mode === "Added" ? "green" : "red";
          return (
            <div key={i} style={{ width: "100%" }}>
              <Box
                key={i}
                p="4"
                cursor="pointer"
                onClick={() => moveToPosition(a)}
                backgroundColor="transparent"
                width="100%"
                // maxWidth="230px"
                wordBreak="break"
                mt="8px"
                ml="5px"
              >
                <HStack display="flex" alignItems="center" justifyContent="space-between" marginBottom="16px" height="fit-content">
                  <Text fontSize="16px" color="#fff">
                    {mode}
                    {/* {a.time} */}
                  </Text>
                  <Box display="flex" gap="8px">
                    <Button
                      height="fit-content"
                      width="auto"
                      color="#fff"
                      padding="0"
                      onClick={() => props.acceptCorrections(a)}
                    >
                      <img alt="Accept" src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/accept.svg"}></img>
                    </Button>
                    <Button
                      height="fit-content"
                      width="auto"
                      color="#fff"
                      padding="0"
                      onClick={() => props.declineCorrections(a)}
                    >
                      <img alt="Reject" src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/reject.svg"}></img>
                    </Button>
                  </Box>
                </HStack>

                <Heading
                  className="text"
                  fontSize="18px"
                  color={bgColor}
                  paddingBottom="12px"
                  fontFamily="Roboto, sans-serif"
                >
                  {a.text === " " ? "<space>" : a.text}
                </Heading>
                {/* <Text fontSize="12px">By : </Text> */}

              </Box>
              <Divider style={{ borderColor: "#C1BFBD" }} />
            </div>
          );
        })
      ) : (
        <p style={{ padding: "24px", margin: 0, color: "#fff" }}>No Corrections</p>
      )}
    </VStack>
  );
};

const mapStateToProps = (state, ownProps) => ({
  corrections: state.correction.corrections,
  ace: ownProps.ace,
});

const mapDispatchToProps = (dispatch) => {
  return {
    acceptCorrections: (data) => dispatch({ type: "accept", payload: data }),
    declineCorrections: (data) => dispatch({ type: "reject", payload: data }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Corrections);
